import { combineReducers } from 'redux'
import shoppingHubReducer from './shoppingHubReducer'
import customerReducer from './customerReducer'

export default combineReducers({
    shoppingHub: shoppingHubReducer,
    customer: customerReducer
})
